module.exports = __webpack_public_path__ + "static/armory-9ee442478259d57018954fe43604bca0.png";